// extracted by mini-css-extract-plugin
export var bounce = "_o0-1";
export var generatingText = "_o0-6";
export var lightning = "_o0-4";
export var popup = "_o0-5";
export var progressBar = "_o0-7";
export var progressFill = "_o0-8";
export var progressShimmer = "_o0-9";
export var progressText = "_o0-a";
export var shimmer = "_o0-3";
export var uploadIcon = "_o0-0";
export var uploadingText = "_o0-2";